import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import { reactQueryClient } from '~/shared/contexts/CommonAppContext';

//  temporary client for dangling components
// When the component is not used in a single page application context
export default function AdHocQueryClient({ children }: { children: React.ReactNode }) {

  return (
    <QueryClientProvider client={reactQueryClient}>
      {children}
    </QueryClientProvider>
  );
};